module.exports = __webpack_public_path__ + "img/cow.ea92a2cd.svg";